import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

type ReconciliationValue = "reconciled" | "not_reconciled";

const options: FilterMultiselectOption[] = [
    { value: "reconciled", label: "Reconciled", searchableLabel: "reconciled" },
    {
        value: "not_reconciled",
        label: "Not reconciled",
        searchableLabel: "not reconciled",
    },
];

export const ReconciliationFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value: ReconciliationValue[] = [
        ...(filters.isReconciled
            ? (["reconciled"] as ReconciliationValue[])
            : []),
        ...(filters.isNotReconciled
            ? (["not_reconciled"] as ReconciliationValue[])
            : []),
    ];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val as ReconciliationValue[];
                    onChange({
                        isReconciled: selected.includes("reconciled")
                            ? true
                            : undefined,
                        isNotReconciled: selected.includes("not_reconciled")
                            ? true
                            : undefined,
                    });
                }}
                name="reconciliation"
                onBlur={noop}
            />
        </div>
    );
};
